<template>
    <v-dialog
        class="activate-qq-dialog"
        :open="show"
        :title="$t('激活QQ员工号登录')"
        @input="handleToggleDialogVisiable"
    >
        <div slot="subtitle">
            {{ $t('激活后可使用QQ员工号登录企点') }}
        </div>
        <div class="body">
            <v-form
                ref="form"
                class="form"
                kind="desc"
                @submit.prevent="handleFormSubmit"
            >
                <v-form-item
                    name="mobile"
                    :rules="formRules.password"
                    error-placement="top-right"
                    :label="$t('登录密码')"
                >
                    <v-input
                        v-model="form.password"
                        password
                        style="width:200px"
                    />
                </v-form-item>
                <v-form-item class="btn-form-item">
                    <v-button
                        type="submit"
                        class="bind-btn"
                        kind="primary"
                        size="large"
                        :loading="formLoading"
                    >
                        {{ $t('立即激活') }}
                    </v-button>
                </v-form-item>
            </v-form>
        </div>
    </v-dialog>
</template>

<script>
import md5 from '@/utils/md5.js';
import { PASSWORD_VALID_REGEXP } from '@/config/pswVaild';
import Gateway from '@/utils/Gateway';
import A1 from '../A1.js';

const BIND_QQ_URL = '/v1/basic.account.account_web.AccountWeb/ActiveQQ'; // 激活qq

export default {
    props: {
        show: {
            type: Boolean,
            default: true,
        },
        aid: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            formLoading: false,
            form: {
                password: '',
            },
            formRules: {
                password: [
                    { required: true, message: this.$t('密码不能为空'), trim: true },
                    { minLength: 6, message: this.$t('密码最小长度为6位'), trim: true },
                    { maxLength: 16, message: this.$t('密码最小长度为16位'), trim: true },
                    {
                        validate(value) {
                            return PASSWORD_VALID_REGEXP.test(value);
                        },
                        message: this.$t('不符合安全强度要求'),
                    },
                ],
            },
        };
    },
    methods: {
        handleFormSubmit() {
            this.formLoading = true;
            const { password } = this.form;
            console.log('this.aid', this.aid);
            console.log('md5(this.aid)', md5(this.aid));
            const params = {
                verify_password: A1.encrypt(this.aid, md5(password)),
                password: md5(password),
            };
            Gateway.post(BIND_QQ_URL, params)
                .then(() => {
                    this.formLoading = false;
                    this.$message.success(this.$t('QQ激活成功'));
                    this.handleToggleDialogVisiable(false);
                    this.$emit('on-success');
                })
                .catch((err) => {
                    this.formLoading = false;
                    this.$message.error(err || this.$t('QQ激活失败'));
                });
        },
        handleToggleDialogVisiable(show) {
            this.$emit('update:show', show);
        },
    },
};
</script>

<style lang="less">
.activate-qq-dialog {
    .v-dialog__content {
        width: 400px;
        padding: 40px 0 0;
    }
    .btn-form-item {
        .v-description-item--text-content {
            width: 0;
        }
    }
    .body {
        padding: 15px 40px;
        .form-label {
            margin-right: 15px;
        }
        .btn-form-item {
            margin-top: 50px;
            .v-form-item__input {
                width: 100%;
                .bind-btn {
                    float: none;
                }
            }
        }
    }
}
</style>
